import { Stack, Group, Text } from '@mantine/core';
import { useState } from 'react';
import { FilterButtons } from 'src/components/FilterButtons/FilterButtons';
import { Rows } from 'src/components/Rows/Rows';
import { formatDecimal, shortenAddress } from 'src/utils';
import { projects } from './projects';

const USECASES = [
  { value: 'lp', label: 'Liquidity Pool' },
  { value: 'collateral', label: 'Collateral' },
  { value: 'swap', label: 'Swap' },
  { value: 'options', label: 'Options' },
  { value: 'staking', label: 'Staking' },
  { value: 'lending/borrowing', label: 'Borrowing/Lending' },
  { value: 'strategy', label: 'Strategy' },
];

export function DefiPage() {
  const [activeFilter, setActiveFilter] = useState('all');
  return (
    <Stack gap={36}>
      <div>
        <FilterButtons
          compact
          data={['all', ...USECASES]}
          value={activeFilter}
          selectMaxW="lg"
          onChange={setActiveFilter}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {projects
          .filter(
            (item) =>
              !!item.url &&
              (activeFilter === 'all' || item.usecases.includes(activeFilter))
          )
          .map((item) => {
            return (
              <a
                key={item.name}
                href={item.url}
                target="_blank"
                className="block"
              >
                <div className="px-6 py-8 border border-solid border-white/[0.14] rounded-[16px]">
                  <Stack gap={20}>
                    <Stack gap={12}>
                      <Group gap={12}>
                        <Text>{item.name}</Text>

                        {item.logo && (
                          <img
                            src={item.logo}
                            alt={`${item.name} Logo`}
                            className="h-[34px]"
                          />
                        )}
                      </Group>

                      {item.currency && (
                        <Text c="var(--mantine-color-main-2)">
                          aprMON / {item.currency}
                        </Text>
                      )}
                    </Stack>

                    <div className="h-[1px] bg-white/[.14]" />

                    <Stack gap={16}>
                      <Rows
                        items={[
                          ...(item.tvl
                            ? [
                                {
                                  label: 'TVL',
                                  value: `$${formatDecimal(item.tvl)}`,
                                },
                              ]
                            : []),
                          {
                            label: 'Use cases',
                            value: item.usecases
                              ?.map(
                                (usecase) =>
                                  USECASES.find((_u) => _u.value === usecase)
                                    ?.label
                              )
                              .join(', '),
                          },
                          ...(item.address
                            ? [
                                {
                                  label: 'Address',
                                  value: shortenAddress(item.address),
                                },
                              ]
                            : []),
                        ]}
                      />
                    </Stack>
                  </Stack>
                </div>
              </a>
            );
          })}
      </div>
    </Stack>
  );
}
